import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "First hike of the season",
  "description": "",
  "published": "2010-04-26T00:00:00.000Z",
  "redirect_from": ["/blog/first-hike-of-the-season/swizec/1317"],
  "categories": "Hiking, life, Outdoors, Recreation, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the past `}{`<`}{`all of my life> years I've been forced to go hiking now and anon by my nature nutter mum.`}</p>
    <p>{`Then last year I started contracting the bug and sort of `}<em parentName="p">{`wanted`}</em>{` to go a few times.`}</p>
    <p>{`This year I totally want to go for a good hike at least once a month.`}</p>
    <p>{`Weird right? Does this mean I'm getting old? Or just that I spend too much time inside?`}</p>
    <p>{`Whatever it is, yesterday the girlfriend and I went for a lovely hike. The first of the season. The destination was this `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Observation_tower",
        "title": "Observation tower"
      }}>{`observation tower`}</a>{` thing upon some hill above Vrhnika.`}</p>
    <p><a parentName="p" {...{
        "href": "http://foursquare.com/venue/2957164"
      }}>{`I foursquared`}</a>{` when we were there of course :P`}</p>
    <p>{`The hike was quite lovely through some woods and such, many birds were chirping and there were no mammals in sight except for some cyclist a dog or two and a few children. There were also some humans.`}</p>
    <p>{`An hour of walking each way ... it hurt a lot more than I thought it would. No soreness today, but it was surprisingly hard yesterday and I felt strangely sleepy as early as midnight. Maybe I'm just not at all in shape yet?`}</p>
    <p>{`Anyhow, here are two photos of the purdiful view we got from the top of the tower.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/5cdcd674-ba89-409a-9ee9-fa1a55421f7c/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=5cdcd674-ba89-409a-9ee9-fa1a55421f7c",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      